import { downgradeInjectable } from '@angular/upgrade/static';
import 'angular';

import 'angular-cookies';

import '../core/core.module.ajs';

import { SessionService }     from './session.service';
import { ValidationsService } from './validations.service';

angular.module('app-lite.sessions', [
  'ngCookies',

  'app-lite.core'
]).service('sessionObjAPI', downgradeInjectable(SessionService))
  .service('validationsApi', downgradeInjectable(ValidationsService));
